import styled from "styled-components";

const Wrapper = styled.header`
    transition : 0.3s;
    position : fixed;
    padding : 0 50px;
    box-sizing : border-box;
    @media screen and (max-width: 1000px) {
        padding : 0 10px;
    }
    display : flex;
    width : 100%;
    top : 0;
    height : 90px;
    background : #fff;
    box-shadow : 0 1px 1px rgba(0,0,0,0.2);
    z-index : 10;
    &.open{
        height : 600px;
        background : rgba(255,255,255,0.9);
        .hamburger{
            .line2{
                display : none;
            }
            .line1{
                transform : rotate(-45deg);
            }
            .line3{
                transform : rotate(45deg);
            }
        }
    }

    .innerHeader{

        display : flex;
        align-items : center;
        width : 100%;
        .hamburger{
            cursor : pointer; 
            background : none;
            width : 90px;
            height : 90px;
            padding : 0;
            justify-content: center;
            align-items: center;
            display: flex;
            border : none;
            
            .inner{
                display : flex;
                flex-flow : column;
                align-items: center;
                justify-content: space-between;
                width : 24px;
                height : 20px;
                >div{
                    width : 100%;
                    height : 3px;
                    background : #000;
                    border-radius : 5px;
                    transform-origin: right;
                    transition : 0.3s;
                }
            }
        }

        .spacer{
            flex : 1;
        }

        .buttons input,button{
            width : 148px;
            height : 24px;
        }

        input[type=button],button{
            background-color : transparent;
            border : none;
            cursor : pointer;
            background-repeat : no-repeat;
            background-position : center right;
        }

        .supportButton{
            background-size: 24px;
            width: 32px;
            height: 32px;
        }

        .user{
            height : 90px;
            width : 90px;
            border : solid 20px #fff !important;
            border-radius : 48px;
            background-color : #051C2C !important;
            font-size : 1.2rem;
            color : #fff;
            position : relative;
            &:hover+.user-overlay{
                display : block;
            }
        }

        .user-overlay{
            &:hover{
                display : block;
            }
            display: none;
            position: absolute;
            background: #fff;
            border : solid thin #ccc;
            top : 90px;
            right: 10px;
            input[type=button]{
                width : 100%;
                text-align : left;
                margin : 0;
                padding : 0;
                font-size : 16px;
                width : 180px;
                padding : 10px 20px;
                display : block;
                border-radius : 10px;
                box-sizing: content-box;
                &:hover{
                    background : #f2f2f2;
                }
            }
            
            ul{
                padding : 0;
                margin : 0;
                
                li{
                    list-style : none;
                    text-align : left;
                    padding : 0;
                    a{
                        text-decoration : none;
                        width : 180px;
                        color : #000;
                        font-size : 16px;
                        padding : 10px 20px;
                        display : block;
                        border-radius : 10px;
                        &:hover{
                            background : #f2f2f2;
                        }
                    }
                }
            }
        }

    }

    
`

export default Wrapper